export default __webpack_public_path__ + "static/media/logo.618a097a.svg";